// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

export default {
    THREADS_CHUNK_SIZE: 20,
};
